import { useContext } from "react";
import ProfileContext from "../contexts/profileContext";


const useProfile = () => useContext(ProfileContext);


export default useProfile;